import { Alert, FormGroup, FormSection } from '@ksyos/design-system';
import type { IService } from '@common/interfaces/';
import { translateKey } from '@frontend/translate';
import { SettingsSwitch } from '../../modals/components/SettingsSwitch';

export interface IRequestRecipientProps {
    error?: string;
    isRequestRecipient: boolean;
    onChange: (isRequestRecipient: boolean) => void;
    onDoValidate?: () => void;
    organizationIsRequestRecipientForSubsequentService?: boolean;
    recipientIsOwnOrganization: boolean;
    service: IService;
    serviceProviderIsRequestRecipient: boolean;
}

export function RequestRecipient(props: IRequestRecipientProps) {
    return (
        <FormSection title={translateKey('serviceOrganizationSetting.requestRecipientTitle')}>
            <FormGroup
                hasErrors={Boolean(props.error)}
                label={translateKey('serviceOrganizationSetting.isRequestRecipient')}
            >
                <SettingsSwitch
                    error={props.error}
                    listKey={`isRequestRecipient-${props.service.id}`}
                    onBlur={() => {
                        if (props.onDoValidate) {
                            props.onDoValidate();
                        }
                    }}
                    onChange={props.onChange}
                    value={props.isRequestRecipient}
                />
            </FormGroup>
            {!props.organizationIsRequestRecipientForSubsequentService &&
                !props.serviceProviderIsRequestRecipient &&
                !props.isRequestRecipient &&
                !props.recipientIsOwnOrganization && (
                    <Alert appearance="warning">
                        {translateKey('serviceProvider.messageNoServiceProviderAndOrganizationRecipient')}
                    </Alert>
                )}

            {props.organizationIsRequestRecipientForSubsequentService && !props.isRequestRecipient && (
                <Alert appearance="warning">
                    {translateKey('serviceOrganizationSetting.organizationIsRequestRecipientForSubsequentService')}
                </Alert>
            )}
        </FormSection>
    );
}
